var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasWrap",attrs:{"id":"idr-pic-canvas"},on:{"mousedown":_vm.handleMouseDown,"mousemove":_vm.handleMouseMove,"mouseup":_vm.handleMouseUp,"contextmenu":_vm.handleContextMenu,"touchstart":_vm.handleTouchStart,"touchmove":_vm.handleTouchMove,"touchend":_vm.handleTouchEnd}},[_c('canvas',{ref:"canvas",style:({
      left: _vm.sourceImage.moveX + 'px',
      top: _vm.sourceImage.moveY + 'px',
      transform: _vm.getTransform(),
    }),attrs:{"id":"pic-canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }